import { ThirdPartyOrganizationsV1NaptimeResource } from './__generated__/ThirdPartyOrganizationsV1';

class ThirdPartyOrganizationsV1 extends ThirdPartyOrganizationsV1NaptimeResource {
  static RESOURCE_NAME = 'thirdPartyOrganizations.v1' as const;
}

export default ThirdPartyOrganizationsV1;
